export default (message, searchList) => {
  const msgItem = searchList.find((l) => l.messageId === message.key);
  return msgItem ? msgItem.message : message.key;
};
